import { Point } from "../frame-stencil";
import { BallActionBase, HandoffActionBase, PlayerActionBase, PossessionActionBase } from "../generic-action";

/** ======== Action Line Types ======== */
export enum BasketballActionLineType {
  CUT = "CUT",
  SCREEN = "SCREEN",
  DRIBBLE = "DRIBBLE",
  PASS = "PASS",
  HASHPASS = "HASHPASS",
  HANDOFF = "HANDOFF",
  CUT_RECEIVING_HANDOFF = "CUT_RECEIVING_HANDOFF",
  SCREEN_RECEIVING_HANDOFF = "SCREEN_RECEIVING_HANDOFF",
}
export type BasketballPlayerActionLineType = BasketballActionLineType.CUT | BasketballActionLineType.SCREEN;
export type BasketballBallActionLineType = BasketballActionLineType.PASS | BasketballActionLineType.HASHPASS;
export type BasketballHandoffActionLineType = BasketballActionLineType.HANDOFF;
export type BasketballPlayerActionReceivingHandoffLineType =
  | BasketballActionLineType.CUT_RECEIVING_HANDOFF
  | BasketballActionLineType.SCREEN_RECEIVING_HANDOFF;
export type BasketballPossessionActionLineType =
  | BasketballActionLineType.DRIBBLE
  | BasketballPlayerActionReceivingHandoffLineType;

/** ======== Actions ======== */
export type BasketballCutAction = PlayerActionBase<BasketballActionLineType.CUT>;
export type BasketballScreenAction = PlayerActionBase<BasketballActionLineType.SCREEN>;
export type BasketballPassAction = BallActionBase<BasketballActionLineType.PASS>;
export interface BasketballHashPassAction extends BallActionBase<BasketballActionLineType.HASHPASS> {
  numberOfHashes: number;
}
export type BasketballHandoffAction = HandoffActionBase<BasketballActionLineType.HANDOFF>;
export type BasketballDribbleAction = PossessionActionBase<BasketballActionLineType.DRIBBLE>;
export type BasketballCutReceivingHandoffAction = PossessionActionBase<BasketballActionLineType.CUT_RECEIVING_HANDOFF>;
export type BasketballScreenReceivingHandoffAction =
  PossessionActionBase<BasketballActionLineType.SCREEN_RECEIVING_HANDOFF>;

/** ======== Action Groups ======== */
export type BasketballPlayerAction = BasketballCutAction | BasketballScreenAction;
export type BasketballBallAction = BasketballPassAction | BasketballHashPassAction;
// export type BasketballHandoffAction = BasketballHandoffAction;
export type BasketballNonHandoffPossessionAction = BasketballDribbleAction;
export type BasketballPlayerActionReceivingHandoff =
  | BasketballCutReceivingHandoffAction
  | BasketballScreenReceivingHandoffAction;

export type BasketballPossessionAction = BasketballNonHandoffPossessionAction | BasketballPlayerActionReceivingHandoff;

export type BasketballAction = (
  | BasketballPlayerAction
  | BasketballBallAction
  | BasketballHandoffAction
  | BasketballPossessionAction
) & {
  classicEndPoint?: Point;
};
